import { createFileRoute } from "@tanstack/react-router";
import AdminMindsetQuotes from "@/pages/admin/AdminMindsetQuotes";

export const Route = createFileRoute("/admin/mindset-quotes")({ component: AdminMindsetQuotes });
